import { useEffect, useState } from 'react';

export default function useOptimisticState<T>(value: T) {
  const state = useState(value);

  const [, setCurrent] = state;

  useEffect(() => {
    setCurrent(value);
  }, [setCurrent, value]);

  return state;
}
